{
  "login": {
    "title": "Добре дошли отново",
    "subtitle": "Влезте в акаунта си, за да продължите",
    "emailTab": "Имейл и парола",
    "smsTab": "SMS",
    "emailLabel": "Имейл",
    "emailPlaceholder": "Имейл",
    "emailRequired": "Моля, въведете вашия имейл!",
    "emailInvalid": "Моля, въведете валиден имейл адрес!",
    "passwordLabel": "Парола",
    "passwordPlaceholder": "Парола",
    "passwordRequired": "Моля, въведете вашата парола!",
    "loginButton": "Вход",
    "loginWithGoogle": "Вход с Google",
    "noAccount": "Нямате акаунт?",
    "signUp": "Регистрация",
    "registerNow": "Регистрирайте се сега",
    "loginFailed": "Входът е неуспешен. Моля, опитайте отново.",
    "googleLoginFailed": "Входът с Google е неуспешен. Моля, опитайте отново.",
    "loginWithCas": "Вход с фирмен акаунт (CAS)",
    "casLoginFailed": "Входът с фирмен акаунт е неуспешен или акаунтът ви няма достъп. Опитайте отново или използвайте друг начин за вход.",
    "casCompleting": "Завършване на входа…",
    "phoneLabel": "Телефонен номер",
    "phonePlaceholder": "Телефонен номер",
    "phoneRequired": "Моля, въведете телефонния си номер!",
    "codeLabel": "Код за потвърждение",
    "codePlaceholder": "Код",
    "codeRequired": "Моля, въведете кода!",
    "sendCode": "Изпрати код",
    "resendCode": "Изпрати отново",
    "codeSent": "Изпратен е код за потвърждение на телефона ви.",
    "phoneInvalid": "Моля, въведете валиден телефонен номер.",
    "invalidCode": "Невалиден код за потвърждение.",
    "codeExpired": "Кодът не е намерен или е изтекъл. Моля, заявете нов.",
    "phoneNotRegistered": "Телефонният номер не е регистриран или не е потвърден.",
    "codeSendFailed": "Кодът не може да бъде изпратен. Моля, опитайте отново.",
    "codeVerifyFailed": "Входът е неуспешен. Моля, проверете кода и опитайте отново.",
    "forgotPassword": "Забравена парола?",
    "emailNotVerified": "Моля, потвърдете имейла си преди вход.",
    "resendVerification": "Изпрати отново имейл за потвърждение",
    "resendVerificationSuccess": "Ако съществува непотвърден акаунт, е изпратен имейл за потвърждение.",
    "fixErrors": "Моля, коригирайте грешките по-долу."
  },
  "register": {
    "title": "Създаване на акаунт",
    "subtitle": "Започнете със SmartAss AI",
    "haveAccount": "Вече имате акаунт?",
    "signIn": "Вход",
    "failed": "Регистрацията е неуспешна. Моля, опитайте отново.",
    "fixErrors": "Моля, коригирайте грешките по-долу.",
    "emailExists": "Вече съществува потребител с този имейл.",
    "phoneExists": "Този телефонен номер вече се използва от друг акаунт. Въведете друг номер или оставете полето празно.",
    "inviteInvalid": "Връзката за покана е невалидна или е изтекла.",
    "nameLabel": "Пълно име",
    "namePlaceholder": "Пълно име",
    "nameRequired": "Моля, въведете пълното си име!",
    "emailLabel": "Имейл",
    "emailPlaceholder": "Имейл",
    "emailRequired": "Моля, въведете вашия имейл!",
    "emailInvalid": "Моля, въведете валиден имейл адрес!",
    "phoneLabel": "Телефонен номер",
    "phonePlaceholder": "+359 888 123 456",
    "passwordLabel": "Парола",
    "passwordPlaceholder": "Парола",
    "passwordRequired": "Моля, въведете вашата парола!",
    "passwordMin": "Паролата трябва да е поне 8 символа!",
    "passwordPattern": "Паролата трябва да съдържа главни и малки букви, цифра и специален символ (@$!%*?&)",
    "confirmPasswordLabel": "Потвърдете паролата",
    "confirmPasswordPlaceholder": "Потвърдете паролата",
    "confirmPasswordRequired": "Моля, потвърдете паролата си!",
    "passwordMismatch": "Двете пароли не съвпадат!",
    "submit": "Регистрация",
    "alreadyHaveAccountDivider": "Вече имате акаунт?",
    "logIn": "Вход",
    "checkEmailTitle": "Проверете имейла си",
    "checkEmailMessage": "Изпратихме ви връзка за потвърждение. Моля, потвърдете имейла си преди вход.",
    "resendVerification": "Изпрати отново имейл за потвърждение",
    "resendVerificationSuccess": "Ако съществува непотвърден акаунт, е изпратен имейл за потвърждение.",
    "tenantInviteTitle": "Покана за екип",
    "tenantInviteDescription": "Поканени сте да се присъедините към екип. Завършете регистрацията, за да приемете поканата."
  },
  "forgotPassword": {
    "title": "Забравена парола",
    "subtitle": "Въведете имейла си и ще ви изпратим връзка за нулиране",
    "emailLabel": "Имейл",
    "emailPlaceholder": "Имейл",
    "emailRequired": "Моля, въведете вашия имейл!",
    "emailInvalid": "Моля, въведете валиден имейл адрес!",
    "submit": "Изпрати връзка",
    "successMessage": "Ако съществува акаунт, е изпратена връзка за нулиране на паролата.",
    "backToLogin": "Обратно към вход",
    "failed": "Връзката не може да бъде изпратена. Моля, опитайте отново."
  },
  "resetPassword": {
    "title": "Нулиране на парола",
    "subtitle": "Изберете нова парола за акаунта си",
    "passwordLabel": "Нова парола",
    "passwordPlaceholder": "Нова парола",
    "passwordRequired": "Моля, въведете новата си парола!",
    "confirmPasswordLabel": "Потвърдете новата парола",
    "confirmPasswordPlaceholder": "Потвърдете новата парола",
    "confirmPasswordRequired": "Моля, потвърдете новата си парола!",
    "submit": "Нулирай паролата",
    "success": "Паролата е актуализирана успешно. Можете да влезете.",
    "failed": "Паролата не може да бъде нулирана. Моля, опитайте отново.",
    "invalidToken": "Тази връзка е невалидна или е изтекла."
  },
  "verifyEmail": {
    "title": "Потвърдете имейла си",
    "verifying": "Потвърждаване на имейла...",
    "success": "Имейлът ви е потвърден. Можете да влезете.",
    "successSignedIn": "Имейлът ви е потвърден.",
    "failed": "Имейлът не може да бъде потвърден. Моля, опитайте отново.",
    "invalidToken": "Тази връзка за потвърждение е невалидна или е изтекла.",
    "backToLogin": "Обратно към вход",
    "backToProfile": "Обратно към профила"
  },
  "verifyLead": {
    "title": "Потвърдете данните за контакт",
    "verifying": "Потвърждаване на данните за контакт...",
    "success": "Данните ви за контакт са потвърдени.",
    "failed": "Данните за контакт не могат да бъдат потвърдени. Връзката може да е изтекла или вече използвана.",
    "invalidToken": "Тази връзка за потвърждение е невалидна или е изтекла.",
    "enterCode": "Въведете 6-цифрения код, който изпратихме на телефона ви.",
    "codeRequired": "Моля, въведете 6-цифрения код.",
    "invalidCode": "Кодът е невалиден. Моля, опитайте отново.",
    "submitCode": "Потвърди",
    "backToLogin": "Обратно към вход"
  },
  "videoMeeting": {
    "loading": "Срещата се зарежда…",
    "notFoundTitle": "Срещата не е намерена",
    "notFoundDescription": "Заявената видеосреща не може да бъде намерена или е изтекла."
  }
}
